import { Button } from '@faire/web--source/slate/Button';
import { StrictLocalMsg } from '@faire/web--source/ui/lib/localization';
import React from 'react';

interface IProps {
  isTreatmentForSccLimitIncreaseExperiment: boolean;
  isLoading: boolean;
  isUpmarketQualified: boolean;
  onClickSccApplication: () => void;
  onSubmit: () => void;
}

export const PrimaryAction: React.FC<IProps> = ({
  isTreatmentForSccLimitIncreaseExperiment,
  isLoading,
  isUpmarketQualified,
  onClickSccApplication,
  onSubmit,
}) => {
  if (isTreatmentForSccLimitIncreaseExperiment) {
    return (
      <Button
        onClick={onClickSccApplication}
        data-test-id="scc-application"
      >
        <StrictLocalMsg
          defaultMessage="Request higher terms"
          description={{
            text: "Button to request higher terms",
            img: "https://cdn.faire.com/fastly/f25842d597327c0c85793ebcd169a31fadb92c97533cb3b0f977f0b140db5283.png",
          }}
        />
      </Button>
    );
  }

  return (
    <Button
      loading={isLoading}
      onClick={onSubmit}
      data-test-id="select-payment-terms"
    >
      <CTATextElement isUpmarketQualified={isUpmarketQualified} />
    </Button>
  );
};


const CTATextElement: React.FC<{
  isUpmarketQualified: boolean;
}> = ({ isUpmarketQualified }) => {
  if (isUpmarketQualified) {
    return (
      <StrictLocalMsg
        defaultMessage="Start shopping"
        description={{
          text: "Button for retailer to start shopping",
          img: "https://cdn.faire.com/fastly/a5fd469e16d735cad25384d828655da96677caa9ecc4f9953719666d7c0482e5.png",
        }}
      />
    );
  }
  return (
    <StrictLocalMsg
      defaultMessage="Shop with payment terms"
      description={{
        text: "Button to select to shop with payment terms",
        img: "https://cdn.faire.com/fastly/ee58f6a470130806b26663ed1eaff1a92135ec4c6f5f4a425e46f4af13bd0206.png",
      }}
    />
  );
};

